import React from 'react';

import {
  tablet,
  desktopMedium,
  desktopLarge,
  minWidth,
  toPx,
} from '../screenSizes';
import { gutter } from '../margins';

export const Container = ({ className, ...restProps }) => (
  <div
    css={`
      display: flex;
      justify-content: center;
    `}
  >
    <div
      css={`
        width: 100%;
        margin-right: ${gutter};
        margin-left: ${gutter};

        ${minWidth(desktopMedium)} {
          max-width: ${toPx(tablet * 1.2)};
        }

        ${minWidth(desktopLarge)} {
          max-width: ${toPx(desktopMedium)};
        }

        ${className};
      `}
      {...restProps}
    />
  </div>
);

export const FullWidthContainer = ({ className, ...restProps }) => (
  <div
    css={`
      width: 100%;
      position: relative;

      ${className};
    `}
    {...restProps}
  />
);



// WEBPACK FOOTER //
// ./app/components/Containers.js